/*
 * BK „Valaki vásárolt” popup (2026-11-04) – sections/bk-live-sales.liquid (overlay csoport)
 * Adat: Shopify Flow „BK social proof” → bk_social.recent (bolt) metafield, a sections/bk-live-sales-feed.liquid adja ki.
 * Csak valós rendelés, név nélkül. Ez a fájl nem talál ki adatot: ha nincs friss vásárlás, nem jelenik meg semmi.
 * (A termékoldali „Best Seller” jelzés tisztán Liquid: snippets/bk-bestseller.liquid – nincs hozzá JS.)
 */
(() => {
  'use strict';

  const STATE_KEY = 'bk-ls:state:v1';
  const FEED_KEY = 'bk-ls:feed:v1';
  const FEED_TTL = 5 * 60 * 1000;

  const store = {
    get(key) {
      try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) { return null; }
    },
    set(key, val) {
      try { sessionStorage.setItem(key, JSON.stringify(val)); } catch (e) { /* privát mód / tiltott tárhely: csak az oldalon belül él */ }
    },
  };

  /* ---------------------------------------------------------------------------------------------------------------
   * Popup
   * ------------------------------------------------------------------------------------------------------------- */
  const PROTECT = '.product-info__buy-buttons buy-buttons, .product-info__buy-buttons .bk-atc-row, .bk-add-btn, [data-bk-ls-protect]';
  const TYPING = 'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="button"]), textarea, select, [contenteditable="true"]';

  let cssPromise = null;
  const loadCss = (href) => {
    if (!cssPromise) {
      cssPromise = new Promise((resolve) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.onload = () => resolve(true);
        link.onerror = () => resolve(false);
        document.head.appendChild(link);
      });
    }
    return cssPromise;
  };

  // A legközelebbi rögzített (fixed, vagy alulra ragadó sticky) ős. A popup saját magát kihagyja.
  const fixedAncestor = (el, self, cache) => {
    const path = [];
    let found = null;
    for (let n = el; n && n.nodeType === 1 && n !== document.body && n !== document.documentElement; n = n.parentElement || (n.getRootNode() && n.getRootNode().host)) {
      if (n === self) { found = null; break; }
      if (cache.has(n)) { found = cache.get(n); break; }
      path.push(n);
      const cs = getComputedStyle(n);
      if (cs.position === 'fixed' || (cs.position === 'sticky' && cs.bottom !== 'auto')) {
        found = (cs.visibility === 'hidden' || Number(cs.opacity) === 0) ? null : n;
        break;
      }
    }
    path.forEach((n) => cache.set(n, found));
    return found;
  };

  const overlaps = (a, b) => !(a.right <= b.left || b.right <= a.left || a.bottom <= b.top || b.bottom <= a.top);

  class BkLiveSales extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      const d = this.dataset;
      try {
        this.i18n = JSON.parse(d.i18n || '{}');
        this.exclude = new Set(JSON.parse(d.exclude || '[]'));
      } catch (e) {
        return;
      }
      this.cfg = {
        first: (parseInt(d.firstDelay, 10) || 8) * 1000,
        gap: (parseInt(d.interval, 10) || 25) * 1000,
        duration: (parseInt(d.duration, 10) || 6) * 1000,
        max: parseInt(d.max, 10) || 12,
        maxAge: (parseInt(d.maxAgeH, 10) || 72) * 3600,
        city: d.showCity === 'true',
        size: d.showSize === 'true',
      };
      this.els = {
        link: this.querySelector('[data-bk-ls-link]'),
        img: this.querySelector('[data-bk-ls-img]'),
        who: this.querySelector('[data-bk-ls-who]'),
        title: this.querySelector('[data-bk-ls-title]'),
        detail: this.querySelector('[data-bk-ls-detail]'),
        close: this.querySelector('[data-bk-ls-close]'),
      };
      if (!this.els.link || !this.els.img) return;

      this.state = store.get(STATE_KEY) || { start: Date.now(), last: 0, n: 0, seen: [], off: false };
      store.set(STATE_KEY, this.state);
      if (this.state.off || this.state.n >= this.cfg.max) return;

      this.retries = 0;
      this.onClose = () => this.dismiss();
      this.onEnter = () => clearTimeout(this.hideTimer);
      this.onLeave = () => { if (this.open) this.armHide(2500); };
      this.onScroll = () => this.queueCheck();
      this.onVisible = () => {
        if (document.hidden) return;
        document.removeEventListener('visibilitychange', this.onVisible);
        this.timer = setTimeout(() => this.tick(), 1500);
      };
      this.els.close.addEventListener('click', this.onClose);
      this.addEventListener('pointerenter', this.onEnter);
      this.addEventListener('pointerleave', this.onLeave);
      this.addEventListener('focusin', this.onEnter);
      this.addEventListener('focusout', this.onLeave);

      this.schedule();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.hideTimer);
      clearTimeout(this.doneTimer);
      this.unwatch();
      document.removeEventListener('visibilitychange', this.onVisible);
      if (this.els && this.els.close) this.els.close.removeEventListener('click', this.onClose);
      this.removeEventListener('pointerenter', this.onEnter);
      this.removeEventListener('pointerleave', this.onLeave);
      this.removeEventListener('focusin', this.onEnter);
      this.removeEventListener('focusout', this.onLeave);
      this._ready = false;
    }

    // Időzítés a látogatás egészére: oldalváltásnál is tartja a szünetet (sessionStorage), oldalbetöltés után min. 4 mp
    schedule(delay) {
      clearTimeout(this.timer);
      const now = Date.now();
      const due = delay != null
        ? now + delay
        : Math.max(this.state.last ? this.state.last + this.cfg.gap : this.state.start + this.cfg.first, now + 4000);
      this.timer = setTimeout(() => this.tick(), due - now);
    }

    async tick() {
      if (this.state.off || this.state.n >= this.cfg.max || !this.isConnected) return;
      if (document.hidden) { document.addEventListener('visibilitychange', this.onVisible); return; }

      const item = this.pick(await this.loadFeed());
      if (!item) return; // nincs friss, megjeleníthető vásárlás – ezen az oldalon nem próbálkozunk tovább

      const css = await loadCss(this.dataset.css);
      if (!css || !this.isConnected) return;

      const pos = this.measure();
      if (pos.blocked) {
        // fiók / ablak nyitva, gépelés, vagy a kosár gombot takarná: kicsit később újra, végül a következő körben
        this.retries += 1;
        this.schedule(this.retries <= 5 ? 6000 : this.cfg.gap);
        if (this.retries > 5) this.retries = 0;
        return;
      }
      this.retries = 0;
      this.show(item, pos);
    }

    async loadFeed() {
      const cached = store.get(FEED_KEY);
      if (cached && cached.url === this.dataset.feedUrl && Date.now() - cached.at < FEED_TTL && Array.isArray(cached.items)) return cached.items;
      let items = [];
      const ctrl = 'AbortController' in window ? new AbortController() : null;
      const kill = ctrl ? setTimeout(() => ctrl.abort(), 8000) : null;
      try {
        const res = await fetch(this.dataset.feedUrl, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined });
        if (res.ok) {
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const node = doc.querySelector('script[data-bk-ls-feed]');
          const parsed = node ? JSON.parse(node.textContent) : [];
          if (Array.isArray(parsed)) items = parsed;
        }
      } catch (e) {
        items = [];
      } finally {
        if (kill) clearTimeout(kill);
      }
      store.set(FEED_KEY, { url: this.dataset.feedUrl, at: Date.now(), items });
      return items;
    }

    pick(items) {
      const now = Date.now() / 1000;
      const seen = new Set(this.state.seen || []);
      return items
        .filter((it) => it && it.h && it.u && it.n && it.i && Number.isFinite(it.t))
        .filter((it) => !this.exclude.has(it.h) && !seen.has(it.h))
        .filter((it) => now - it.t <= this.cfg.maxAge && it.t <= now + 300)
        .sort((a, b) => b.t - a.t)[0] || null;
    }

    // Hova kerülhet a popup úgy, hogy semmilyen rögzített elemet ne takarjon (ragadós kosár sáv, KaChing gomb, chat, nyelvválasztó…)?
    measure() {
      const vw = document.documentElement.clientWidth;
      const vh = window.innerHeight;
      const mobile = vw < 700;
      const width = mobile ? Math.min(vw - 24, 420) : 360;
      const left = mobile ? Math.round((vw - width) / 2) : (this.classList.contains('bk-ls--right') ? vw - 24 - width : 24);
      const height = this.open ? this.getBoundingClientRect().height : 80;
      const cache = new Map();
      const restorePE = this.style.pointerEvents;
      this.style.pointerEvents = 'none';

      let blocked = false;
      const active = document.activeElement;
      if (active && active !== document.body && active.matches && active.matches(TYPING) && !this.contains(active)) blocked = true;

      // Nyitott fiók / modális ablak: a képernyő közepét takaró nagy rögzített réteg
      if (!blocked) {
        const center = fixedAncestor(document.elementFromPoint(vw / 2, vh / 2), this, cache);
        if (center) {
          const r = center.getBoundingClientRect();
          if (r.width > vw * 0.6 && r.height > vh * 0.5) blocked = true;
        }
      }

      // Rögzített elemek a popup sávjában (alsó képernyőfél). Visszaadja a talált elemek téglalapjait.
      const scan = (l, w) => {
        const found = new Map();
        const xs = [l + 6, l + w * 0.25, l + w * 0.5, l + w * 0.75, l + w - 6];
        for (let y = vh - 2; y > vh * 0.45; y -= 10) {
          for (const x of xs) {
            const f = fixedAncestor(document.elementFromPoint(x, y), this, cache);
            if (!f || found.has(f)) continue;
            const r = f.getBoundingClientRect();
            if (r.height > vh * 0.5) continue; // teljes magas keskeny sáv (pl. görgetés-jelző) – nem alsó elem
            found.set(f, r);
          }
        }
        return [...found.values()];
      };

      let top = vh;
      let l = left;
      let w = width;
      if (!blocked) {
        let rects = scan(l, w);
        // Képernyő széléhez tapadó keskeny fülek (Essentials Bundle fül, kívánságlista szív): a popup mellettük fér el,
        // keskenyebben, nem kerül föléjük a képernyő közepére
        const tabs = rects.filter((r) => r.width <= 72 && (r.left <= 4 || r.right >= vw - 4));
        if (tabs.length) {
          let L = l;
          let R = l + w;
          tabs.forEach((r) => { if (r.left <= 4) L = Math.max(L, Math.ceil(r.right + 8)); else R = Math.min(R, Math.floor(r.left - 8)); });
          if (R - L >= 260) {
            l = L;
            w = R - L;
            rects = scan(l, w);
          }
        }
        rects.forEach((r) => { if (r.right > l && r.left < l + w && r.top < top) top = r.top; });
      }
      this.style.pointerEvents = restorePE;

      const bottom = Math.max(12, Math.ceil(vh - top + 8));
      if (bottom + height > vh * 0.55) blocked = true;

      // A termékoldali kosár gombot / mennyiségválasztót soha ne takarja
      if (!blocked) {
        const box = { left: l, right: l + w, bottom: vh - bottom, top: vh - bottom - height };
        for (const el of document.querySelectorAll(PROTECT)) {
          if (this.contains(el)) continue;
          const r = el.getBoundingClientRect();
          if (r.width && r.height && overlaps(box, r)) { blocked = true; break; }
        }
      }
      return { blocked, bottom, left: l, width: w };
    }

    relTime(t) {
      const s = Math.max(0, Date.now() / 1000 - t);
      if (s < 120) return this.i18n.now;
      if (s < 3600) return this.i18n.min.replace('__N__', Math.floor(s / 60));
      if (s < 48 * 3600) return this.i18n.hour.replace('__N__', Math.floor(s / 3600));
      return this.i18n.day.replace('__N__', Math.floor(s / 86400));
    }

    async show(item, pos) {
      const { link, img, who, title, detail } = this.els;
      link.href = item.u;
      title.textContent = item.n;
      who.textContent = this.cfg.city && item.c ? this.i18n.who + ' · ' + item.c : this.i18n.who;
      const parts = [];
      // Csak valódi méretjelölés (cipőméret, ruhaméret) – „120 cm”, „SINGLE BOX” és társai nem
      if (this.cfg.size && item.v && /^(\d{2}([.,]\d)?|\d{2}\s?[\d/]+\s?\/?\s?\d*|[2-5]?X{0,3}[SML]|XXS|XS|\d{2}\/\d{2})$/i.test(item.v.trim())) {
        parts.push(this.i18n.size.replace('__S__', item.v.trim()));
      }
      parts.push(this.relTime(item.t));
      detail.textContent = parts.join(' · ');

      if (img.getAttribute('src') !== item.i) {
        img.src = item.i;
        try {
          await Promise.race([img.decode(), new Promise((r) => setTimeout(r, 1500))]);
        } catch (e) { /* a kép hibája nem állítja meg a popupot – a képhely szürke háttere marad */ }
      }
      if (!this.isConnected) return;

      this.setPos(pos);
      this.hidden = false;
      void this.offsetWidth; // a belépő átmenet induljon
      this.classList.add('is-open');
      this.open = true;

      this.state.n += 1;
      this.state.last = Date.now();
      this.state.seen = (this.state.seen || []).concat(item.h).slice(-40);
      store.set(STATE_KEY, this.state);

      this.watch();
      this.armHide(this.cfg.duration);
    }

    setPos(pos) {
      this.style.setProperty('--bk-ls-bottom', pos.bottom + 'px');
      this.style.setProperty('--bk-ls-left', pos.left + 'px');
      this.style.setProperty('--bk-ls-w', pos.width + 'px');
    }

    armHide(ms) {
      clearTimeout(this.hideTimer);
      this.hideTimer = setTimeout(() => this.hide(), ms);
    }

    hide() {
      if (!this.open) return;
      this.open = false;
      clearTimeout(this.hideTimer);
      this.unwatch();
      this.classList.remove('is-open');
      clearTimeout(this.doneTimer);
      this.doneTimer = setTimeout(() => { if (!this.open) this.hidden = true; }, 260);
      if (!this.state.off && this.state.n < this.cfg.max) this.schedule();
    }

    dismiss() {
      this.state.off = true; // bezárás után ebben a látogatásban több nem jön
      store.set(STATE_KEY, this.state);
      clearTimeout(this.timer);
      this.hide();
    }

    // Megjelenés közben: ha felbukkan egy alsó sáv (pl. ragadós kosár), feljebb lép; ha fiók nyílik vagy a kosár gombot takarná, eltűnik
    watch() {
      if (this.watching) return;
      this.watching = true;
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.checkInterval = setInterval(() => this.queueCheck(), 700);
    }

    unwatch() {
      if (!this.watching) return;
      this.watching = false;
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      clearInterval(this.checkInterval);
      clearTimeout(this.checkTimer);
      if (this.checkFrame) cancelAnimationFrame(this.checkFrame);
      this.checkFrame = 0;
      this.checkPending = false;
    }

    // Legfeljebb 250 ms-onként egy mérés, képkockához igazítva
    queueCheck() {
      if (!this.open || this.checkPending) return;
      this.checkPending = true;
      const wait = Math.max(0, 250 - (Date.now() - (this.lastCheck || 0)));
      this.checkTimer = setTimeout(() => {
        this.checkFrame = requestAnimationFrame(() => {
          this.checkFrame = 0;
          this.checkPending = false;
          this.lastCheck = Date.now();
          if (!this.open) return;
          const pos = this.measure();
          if (pos.blocked) this.hide();
          else this.setPos(pos);
        });
      }, wait);
    }
  }

  if (!customElements.get('bk-live-sales')) customElements.define('bk-live-sales', BkLiveSales);
})();
